import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, BarChart3, DollarSign, Users, Menu } from 'lucide-react';
import FloatingAIButton from '@/components/FloatingAIButton';
import { cn } from '@/lib/utils';

const MobileLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Hide header on home page (CostControlHome has its own header)
  const hideHeader = location.pathname === '/';

  const navItems = [
    { path: '/', icon: Home, labelKey: 'nav.home', testId: 'nav-home' },
    { path: '/progress', icon: BarChart3, labelKey: 'nav.progress', testId: 'nav-progress' },
    { path: '/costs', icon: DollarSign, labelKey: 'nav.costs', testId: 'nav-costs' },
    { path: '/manpower', icon: Users, labelKey: 'nav.manpower', testId: 'nav-manpower' },
    { path: '/settings', icon: Menu, labelKey: 'nav.more', testId: 'nav-more' }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header with Oracle Logo - Hidden on home page */}
      {!hideHeader && (
        <header className="sticky top-0 z-40 bg-white border-b border-gray-100 px-4 py-3">
          <div className="flex items-center justify-between max-w-7xl mx-auto">
            <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate('/')}>
              <img 
                src="https://logos-world.net/wp-content/uploads/2020/09/Oracle-Logo.png" 
                alt="Oracle" 
                className="h-6 w-auto"
              />
              <span className="font-semibold text-gray-800 text-sm">{t('home.title')}</span>
            </div>
            <div className="text-xs text-gray-500">
              {t('home.headerTag')}
            </div>
          </div>
        </header>
      )}

      {/* Main Content */}
      <main className={`pb-20 ${hideHeader ? '' : 'px-4 pt-4'}`}>
        {children}
      </main>

      {/* Floating AI Assistant Button */}
      <FloatingAIButton />

      {/* Bottom Navigation */}
      <nav className="bottom-nav" data-testid="bottom-navigation">
        <div className="flex justify-around items-center h-16 max-w-2xl mx-auto">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            const Icon = item.icon;

            return (
              <button
                key={item.path}
                data-testid={item.testId}
                onClick={() => navigate(item.path)}
                className={cn(
                  "flex flex-col items-center justify-center gap-1 px-4 py-2 rounded-lg transition-all",
                  isActive ? "text-sky-600" : "text-gray-400 hover:text-gray-600"
                )}
              >
                <Icon 
                  size={24} 
                  strokeWidth={isActive ? 2.5 : 2}
                />
                <span className="text-xs font-medium">{t(item.labelKey)}</span>
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
};

export default MobileLayout;
